<template>
    <div>
        <vx-card v-bind:title="room_name + '-호실관리'" write-toggler @writeClick="popupOpen">
            <div class="flex justify-end flex-wrap">
                <!-- <vs-chip color="primary">
                    <vs-avatar color="primary" icon-pack="feather" icon="icon-edit-2" />
                    <span>+ 호실관리</span>
                </vs-chip> -->
            </div>
            <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <table style="width:100%;" class="border-collapse">
                        <colgroup>
                            <col width="20%" />
                            <col width="20%" />
                            <col width="20%" />
                            <col width="20%" />
                            <col width="20%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">병동명</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">호실</th>
                                <!-- <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">담당자</th> -->
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">직통번호</th>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">관리</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in list_medical_room_number" :key="index">
                                <td class="border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_ROOM_NM }}</td>
                                <td class="border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_ROOM_NUMBER_NM }}</td>
                                <td class="border border-solid d-theme-border-grey-light text-center">{{ item.MEDICAL_ROOM_TEL }}</td>
                                <td class="border border-solid d-theme-border-grey-light text-center" style="padding:10px;">
                                    <vs-row vs-type="flex" vs-justify="center">
                                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                                            <vx-tooltip text="병동수정" position="top">
                                                <vs-button color="warning" type="line" icon-pack="feather" icon="icon-edit-2" @click="modifyPopup(index)" />
                                            </vx-tooltip>
                                            <vx-tooltip text="병동삭제" position="top">
                                                <vs-button color="danger" type="line" icon-pack="feather" icon="icon-x" @click="removeMedicalRoomConfirm(index)" />
                                            </vx-tooltip>
                                        </vs-col>
                                    </vs-row>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </vx-card>

        <vs-popup title="호실 등록 및 수정" :active.sync="openPopup">
            <form>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full mb-3">
                        <vs-input class="w-full" name="" label="병동" placeholder="병동명을 입력해주세요." v-model="room_name" ref="medicalName" disabled />
                        <!-- <span class="text-danger text-sm" v-if="flag1">병동명을 입력해주세요.</span> -->
                    </div>
                    <div class="vx-col w-full">
                        <vs-input class="w-full" name="" label="호실" placeholder="호실을 입력해주세요." v-model="room_number" ref="medicalName" />
                        <!-- <span class="text-danger text-sm" v-if="flag1">병동명을 입력해주세요.</span> -->
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full text-right">
                        <vs-button class="mr-3 mb-2" @click="roomSave">저장</vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click="openPopup = false">닫기</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
export default {
    data() {
        return {
            openPopup: false,
            medical_room_seq: '',
            list_medical_room_number: [],
            selectIndex: -1,
            room_name: '',
            room_number: '',
        };
    },
    methods: {
        popupOpen() {
            this.openPopup = true;
        },
        async init() {
            const { data } = await axiosClass.get('/api/management/wardList/' + this.medical_room_seq, {}, true);
            this.room_name = data.medical_room_nm;
            this.list_medical_room_number = data.medical_room_number_list;
        },
        modifyPopup(index) {
            this.selectIndex = index;
            this.room_number = this.list_medical_room_number[index].MEDICAL_ROOM_NUMBER_NM;
            this.openPopup = true;
        },

        removeMedicalRoomConfirm(index) {
            this.selectIndex = index;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '해당 병동(' + this.list_medical_room_number[index].MEDICAL_ROOM_NUMBER_NM + ')를 정말로 삭제하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: this.removeMedicalRoom,
            });
        },
        async removeMedicalRoom() {
            // console.log(this.list_medical_room_number[this.selectIndex].MEDICAL_ROOM_NUMBER_CD);
            const { data } = await axiosClass.delete('/api/management/wardList/' + this.medical_room_seq + '/' + this.list_medical_room_number[this.selectIndex].MEDICAL_ROOM_NUMBER_CD, {}, true);
            this.list_medical_room_number.splice(this.selectIndex, 1);
            this.$vs.notify({
                color: 'primary',
                title: '삭제',
                text: '호실이 삭제되었습니다.',
                position: 'top-right',
                iconPack: 'feather',
            });
        },
        async roomSave() {
            let medical_room_number_cd = '';
            let jsonData = {};
            if (this.selectIndex == -1) {
                medical_room_number_cd = '';
            } else {
                medical_room_number_cd = this.list_medical_room_number[this.selectIndex].MEDICAL_ROOM_NUMBER_CD;
            }

            jsonData = {
                medical_room_number_cd: medical_room_number_cd,
                room_number: this.room_number,
            };

            const { data } = await axiosClass.post('/api/management/wardList/' + this.medical_room_seq, jsonData, true);
            this.openPopup = false;
            if (this.selectIndex == -1) {
                this.list_medical_room_number.push(data.room_number_data);
                this.$vs.notify({
                    color: 'primary',
                    title: '저장',
                    text: '호실이 저장되었습니다.',
                    position: 'top-right',
                    iconPack: 'feather',
                });
            } else {
                this.list_medical_room_number[this.selectIndex] = data.room_number_data;
                this.$vs.notify({
                    color: 'primary',
                    title: '수정.',
                    text: '호실이 수정되었습니다.',
                    position: 'top-right',
                    iconPack: 'feather',
                });
            }
            this.selectIndex = -1;
        },
    },
    mounted() {
        console.log('medical_room_seq');
        console.log(this.$route.params.medical_room_seq);
        this.medical_room_seq = this.$route.params.medical_room_seq;
        this.init();
    },
};
</script>

<style></style>
